import { lazy, Suspense } from 'react'
import { GlobalApp } from './components/GlobalApp/GlobalApp'
import { PrivacyControls } from './components/PrivacyControls/PrivacyControls'

const USAtlasApp = lazy(() => import('./USAtlasApp'))

export default function App() {
  return <>
    {window.location.pathname === '/us'
      ? <Suspense fallback={<div className="route-loading">LOADING THE UNITED STATES ATLAS…</div>}><USAtlasApp/></Suspense>
      : <GlobalApp/>}
    <PrivacyControls/>
  </>
}
